import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createCollaboratorTaskAsync, deleteCollaboratorTaskAsync, getAllCollaboratorTasksAsync, getCollaboratorTaskByIdAsync, updateCollaboratorTaskAsync } from './collaboratorTaskThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const collaboratorTaskSlice = createSlice({
    name: 'collaboratorTask',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createCollaboratorTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCollaboratorTaskAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorTask = action.payload;
        })
            .addCase(createCollaboratorTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCollaboratorTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCollaboratorTaskAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorTask = action.payload;
        })
            .addCase(updateCollaboratorTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllCollaboratorTasksAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCollaboratorTasksAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorTasks = action.payload;
        })
            .addCase(getAllCollaboratorTasksAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCollaboratorTaskByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCollaboratorTaskByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.collaboratorTask = action.payload;
        })
            .addCase(getCollaboratorTaskByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCollaboratorTaskAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCollaboratorTaskAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteCollaboratorTaskAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default collaboratorTaskSlice.reducer;
